export default __webpack_public_path__ + "static/media/O-037.cf554905.png";